import { useState } from "react";
import { GridDataStateChangeEvent } from "@progress/kendo-react-grid";
import { DataResult, process } from "@progress/kendo-data-query";
import { draftAPI } from "../../../../utils/api";

export const useClosedForCommentTableController = (props: any) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [rows, setRows] = useState<any>(props.rows ?? []);
  const [columns, setColumns] = useState<any>(props.columns ?? []);
  const [dataState, setDataState] = useState<any>({
    skip: 0,
    take: 20,
    sort: [{ field: "id", dir: "desc" }],
  });
  const [dataResult, setDataResult] = useState<DataResult>(
    process(props.rows, dataState)
  );
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [proposedRuleData, setProposedRuleData] = useState<any>(undefined);


  const dataStateChange = (event: GridDataStateChangeEvent) => {
    setDataResult(process(props.rows, event.dataState));
    setDataState(event.dataState);
  };

  const toggleDialog = async (id?: number) => {
    dialogOpen ? setDialogOpen(false) : setDialogOpen(true);
    if (id) {
      setProposedRuleData(undefined);
      let draftData = await draftAPI.getDraft(id);
      setProposedRuleData(draftData);
    }
  };

  return {
    // variable
    loading,
    rows,
    columns,
    dataState,
    dataResult,
    dialogOpen,
    proposedRuleData,
    // functions
    toggleDialog,
    dataStateChange,
  };
};
